/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './progress-bar.component.ngfactory';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/progress-bar.component';
import * as i3 from './body-row-wrapper.component.ngfactory';
import * as i4 from '@angular/common';
import * as i5 from '@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component';
import * as i6 from './body-row.component.ngfactory';
import * as i7 from '@swimlane/ngx-datatable/release/components/body/body-row.component';
import * as i8 from '@swimlane/ngx-datatable/release/services/scrollbar-helper.service';
import * as i9 from './scroller.component.ngfactory';
import * as i10 from '@swimlane/ngx-datatable/release/components/body/scroller.component';
import * as i11 from '@swimlane/ngx-datatable/release/components/body/body.component';
import * as i12 from './selection.component.ngfactory';
import * as i13 from '@swimlane/ngx-datatable/release/components/body/selection.component';
const styles_DataTableBodyComponent:any[] = ([] as any[]);
export const RenderType_DataTableBodyComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableBodyComponent,data:{}});
function View_DataTableBodyComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'datatable-progress',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_ProgressBarComponent_0,
      i1.RenderType_ProgressBarComponent)),i0.ɵdid(49152,(null as any),0,i2.ProgressBarComponent,
      ([] as any[]),(null as any),(null as any)),(_l()(),i0.ɵted((null as any),['\n      ']))],
      (null as any),(null as any));
}
function View_DataTableBodyComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'datatable-row-wrapper',
      [['class','datatable-row-wrapper']],(null as any),[[(null as any),'rowContextmenu'],
          [(null as any),'contextmenu']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('contextmenu' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,2).onContextmenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('rowContextmenu' === en)) {
          const pd_1:any = ((<any>_co.rowContextmenu.emit($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_DataTableRowWrapperComponent_0,i3.RenderType_DataTableRowWrapperComponent)),
      i0.ɵdid(278528,(null as any),0,i4.NgStyle,[i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),i0.ɵdid(49152,(null as any),
          0,i5.DataTableRowWrapperComponent,([] as any[]),{rowDetail:[0,'rowDetail'],
              detailRowHeight:[1,'detailRowHeight'],expanded:[2,'expanded'],row:[3,
                  'row']},{rowContextmenu:'rowContextmenu'}),(_l()(),i0.ɵted(0,['\n          '])),
      (_l()(),i0.ɵeld(0,(null as any),0,2,'datatable-body-row',[['tabindex','-1']],
          [[8,'className',0],[4,'height','px'],[4,'width','px']],[[(null as any),'activate'],
              [(null as any),'keydown']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,5).onKeyDown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('activate' === en)) {
              const pd_1:any = ((<any>i0.ɵnov((<any>(<any>_v.parent).parent),3).onActivate($event,
                  _v.context.index)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i6.View_DataTableBodyRowComponent_0,i6.RenderType_DataTableBodyRowComponent)),
      i0.ɵdid(49152,(null as any),0,i7.DataTableBodyRowComponent,[i8.ScrollbarHelper,
          i0.ElementRef],{columns:[0,'columns'],innerWidth:[1,'innerWidth'],rowClass:[2,
          'rowClass'],row:[3,'row'],offsetX:[4,'offsetX'],isSelected:[5,'isSelected'],
          rowHeight:[6,'rowHeight']},{activate:'activate'}),(_l()(),i0.ɵted((null as any),
          ['\n          '])),(_l()(),i0.ɵted(0,['\n        ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getRowsStyles(_v.context.$implicit);
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.rowDetail;
    const currVal_2:any = _co.getDetailRowHeight(_v.context.$implicit,_v.context.index);
    const currVal_3:any = (_v.context.$implicit.$$expanded === 1);
    const currVal_4:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_8:any = _co.columns;
    const currVal_9:any = _co.innerWidth;
    const currVal_10:any = _co.rowClass;
    const currVal_11:any = _v.context.$implicit;
    const currVal_12:any = _co.offsetX;
    const currVal_13:any = i0.ɵnov((<any>(<any>_v.parent).parent),3).getRowSelected(_v.context.$implicit);
    const currVal_14:any = _co.getRowHeight(_v.context.$implicit);
    _ck(_v,5,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
  },(_ck,_v) => {
    const currVal_5:any = i0.ɵnov(_v,5).cssClass;
    const currVal_6:any = i0.ɵnov(_v,5).rowHeight;
    const currVal_7:any = i0.ɵnov(_v,5).columnsTotalWidths;
    _ck(_v,4,0,currVal_5,currVal_6,currVal_7);
  });
}
function View_DataTableBodyComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),5,'datatable-scroller',
      [['class','datatable-scroll']],[[4,'height','px'],[4,'width','px']],[[(null as any),
          'scroll']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('scroll' === en)) {
          const pd_0:any = ((<any>_co.onBodyScroll($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i9.View_ScrollerComponent_0,i9.RenderType_ScrollerComponent)),i0.ɵdid(245760,
      [[1,4]],0,i10.ScrollerComponent,[i0.ElementRef,i0.Renderer],{scrollbarV:[0,'scrollbarV'],
          scrollbarH:[1,'scrollbarH'],scrollHeight:[2,'scrollHeight'],scrollWidth:[3,
              'scrollWidth']},{scroll:'scroll'}),(_l()(),i0.ɵted(0,['\n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),0,1,(null as any),View_DataTableBodyComponent_3)),
      i0.ɵdid(802816,(null as any),0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf'],ngForTrackBy:[1,'ngForTrackBy']},
          (null as any)),(_l()(),i0.ɵted(0,['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.scrollbarV;
    const currVal_3:any = _co.scrollbarH;
    const currVal_4:any = _co.scrollHeight;
    const currVal_5:any = _co.columnGroupWidths.total;
    _ck(_v,1,0,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = _co.temp;
    const currVal_7:any = _co.rowTrackingFn;
    _ck(_v,4,0,currVal_6,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).scrollHeight;
    const currVal_1:any = i0.ɵnov(_v,1).scrollWidth;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_DataTableBodyComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'empty-row']],[[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.emptyMessage;
        _ck(_v,0,0,currVal_0);
      });
}
export function View_DataTableBodyComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{scroller:0}),(_l()(),i0.ɵted((null as any),
      ['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),11,'datatable-selection',
      ([] as any[]),(null as any),[[(null as any),'select'],[(null as any),'activate']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:i11.DataTableBodyComponent = _v.component;
        if (('select' === en)) {
          const pd_0:any = ((<any>_co.select.emit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('activate' === en)) {
          const pd_1:any = ((<any>_co.activate.emit($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i12.View_DataTableSelectionComponent_0,i12.RenderType_DataTableSelectionComponent)),
      i0.ɵdid(49152,[['selector',4]],0,i13.DataTableSelectionComponent,([] as any[]),
          {rows:[0,'rows'],selected:[1,'selected'],selectEnabled:[2,'selectEnabled'],
              selectionType:[3,'selectionType'],rowIdentity:[4,'rowIdentity'],selectCheck:[5,
                  'selectCheck']},{activate:'activate',select:'select'}),(_l()(),i0.ɵted(0,
          ['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),0,1,(null as any),
          View_DataTableBodyComponent_1)),i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(0,['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),0,1,(null as any),View_DataTableBodyComponent_2)),
      i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted(0,['\n      '])),(_l()(),i0.ɵand(16777216,
          (null as any),0,1,(null as any),View_DataTableBodyComponent_4)),i0.ɵdid(16384,
          (null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted(0,['\n    '])),(_l()(),i0.ɵted((null as any),
          ['\n  ']))],(_ck,_v) => {
    var _co:i11.DataTableBodyComponent = _v.component;
    const currVal_0:any = _co.temp;
    const currVal_1:any = _co.selected;
    const currVal_2:any = _co.selectEnabled;
    const currVal_3:any = _co.selectionType;
    const currVal_4:any = _co.rowIdentity;
    const currVal_5:any = _co.selectCheck;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = _co.loadingIndicator;
    _ck(_v,6,0,currVal_6);
    const currVal_7:any = ((_co.rows == null)? (null as any): _co.rows.length);
    _ck(_v,9,0,currVal_7);
    const currVal_8:boolean = !((_co.rows == null)? (null as any): _co.rows.length);
    _ck(_v,12,0,currVal_8);
  },(null as any));
}
export function View_DataTableBodyComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-body',
      [['class','datatable-body']],[[4,'width',(null as any)],[4,'height',(null as any)]],
      (null as any),(null as any),View_DataTableBodyComponent_0,RenderType_DataTableBodyComponent)),
      i0.ɵdid(245760,(null as any),0,i11.DataTableBodyComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).bodyWidth;
    const currVal_1:any = i0.ɵnov(_v,1).bodyHeight;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const DataTableBodyComponentNgFactory:i0.ComponentFactory<i11.DataTableBodyComponent> = i0.ɵccf('datatable-body',
    i11.DataTableBodyComponent,View_DataTableBodyComponent_Host_0,{scrollbarV:'scrollbarV',
        scrollbarH:'scrollbarH',loadingIndicator:'loadingIndicator',externalPaging:'externalPaging',
        rowHeight:'rowHeight',offsetX:'offsetX',emptyMessage:'emptyMessage',selectionType:'selectionType',
        selected:'selected',rowIdentity:'rowIdentity',rowDetail:'rowDetail',selectCheck:'selectCheck',
        trackByProp:'trackByProp',rowClass:'rowClass',pageSize:'pageSize',rows:'rows',
        columns:'columns',offset:'offset',rowCount:'rowCount',innerWidth:'innerWidth',
        bodyHeight:'bodyHeight'},{scroll:'scroll',page:'page',activate:'activate',
        select:'select',detailToggle:'detailToggle',rowContextmenu:'rowContextmenu'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./aot_output/~/@swimlane/ngx-datatable/release/components/body/body.component.ngfactory.ts